module.exports = __webpack_public_path__ + "img/ic-1.60b4b47.svg";